//ChartElement sizes
export const DEFAULT_CHART_WIDTH = 600
export const DEFAULT_CHART_HEIGHT = 400

//ImageElement sizes
export const DEFAULT_IMAGE_WIDTH = 300
export const DEFAULT_IMAGE_HEIGHT = 200

//PieChartElement sizes
export const DEFAULT_PIE_CHART_WIDTH = 500
export const DEFAULT_PIE_CHART_HEIGHT = 500

//TextElement sizes
export const DEFAULT_TEXT_SIZES = {
  heading: { width: 400, height: 60 },
  text: { width: 200, height: 40 },
}

//TableElement sizes
export const DEFAULT_TABLE_WIDTH = 800
export const DEFAULT_TABLE_HEIGHT = 600

//TimeSeriesChartElement sizes
export const DEFAULT_TIMESERIES_WIDTH = 700
export const DEFAULT_TIMESERIES_HEIGHT = 450
